<template>
    <div class="homePage">
        <p class="welcome">欢迎页面</p>
        <div class="homePage_box">
            <p class="homePage_box_mess">
                您好，<span>{{ userInfo.name }}</span>,
                欢迎使用增材云业务管理后台。<!--您上次登录的时间：2022-10-20
                15：40：33，上次登录IP：168.10.10.10-->
            </p>
            <div class="homePage_box_center">
                <div class="homePage_box_center_title">
                    <h5>待办中心</h5>
                </div>
                <div class="center_list">
                    <div class="center_list_box">
                        <h5>入驻审核</h5>
                        <div class="message_list_box">
                            <div class="message_list">
                                <p>设计师入驻</p>
                                <p class="message_list_num" @click="onClickMessDetail('/designerEnter')">
                                    {{ designMap.examineDesigner }}</p>
                            </div>
                            <div class="message_list">
                                <p>服务商入驻</p>
                                <p class="message_list_num" @click="onClickMessDetail('/facilitatorEnter')">
                                    {{ printMap.examineProviders }}</p>
                            </div>
                            <div class="message_list">
                                <p>商家入驻</p>
                                <p class="message_list_num" @click="onClickMessDetail('/merchantEnter')">
                                    {{ printMap.examineShopSettled }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="center_list_box">
                        <h5>打印审核</h5>
                        <div class="message_list_box">
                            <div class="message_list">
                                <p>材料审核</p>
                                <p class="message_list_num" @click="onClickMessDetail('/materialsAudit')">
                                    {{ printMap.examineMaterial }}</p>
                            </div>
                            <div class="message_list">
                                <p>服务审核</p>
                                <p class="message_list_num" @click="onClickMessDetail('/serverAudit')">
                                    {{ printMap.examineServiceability }}</p>
                            </div>
                            <div class="message_list">
                                <p>成品审核</p>
                                <p class="message_list_num" @click="onClickMessDetail('/productAudit')">
                                    {{ printMap.examinePresentation }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="center_list_box">
                        <h5>设计审核</h5>
                        <div class="message_list_box">
                            <div class="message_list">
                                <p>需求审核</p>
                                <p class="message_list_num" @click="onClickMessDetail('/demandAudit')">
                                    {{ designMap.examineDemand }}</p>
                            </div>
                            <div class="message_list">
                                <p>模型审核</p>
                                <p class="message_list_num" @click="onClickMessDetail('/modelAudit')">
                                    {{ designMap.examineModel }}</p>
                            </div>
                            <div class="message_list">
                                <p>成果审核</p>
                                <p class="message_list_num" @click="onClickMessDetail('/worksAudit')">
                                    {{ designMap.examineProduct }}</p>
                            </div>
                            <div class="message_list">
                                <p>平面设计审核</p>
                                <p class="message_list_num" @click="onClickMessDetail('/designAudit')">
                                    {{ designMap.examineDesign }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="center_list_box">
                        <h5>商品审核</h5>
                        <div class="message_list_box">
                            <div class="message_list">
                                <p>商品审核</p>
                                <p class="message_list_num" @click="onClickMessDetail('/goodsAudit')">
                                    {{ printMap.examineGoods }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="homePage_box_center">
                <div class="homePage_box_center_title">
                    <h5>统计中心</h5>
                </div>
                <div class="center_list">
                    <div class="center_list_box center_list_box2">
                        <h5>打印统计</h5>
                        <div class="message_list_box">
                            <div class="message_list">
                                <p>服务商总数</p>
                                <p class="message_list_num" @click="onClickMessDetail('/shopProviders')">
                                    {{ printMap.passProviders }}</p>
                            </div>
                            <div class="message_list">
                                <p>材料总数</p>
                                <p class="message_list_num" @click="onClickMessDetail('/materialsAudit')">
                                    {{ printMap.passMaterial }}</p>
                            </div>
                            <div class="message_list">
                                <p>服务总数</p>
                                <p class="message_list_num" @click="onClickMessDetail('/serverAudit')">
                                    {{ printMap.passServiceability }}</p>
                            </div>
                            <div class="message_list">
                                <p>成品总数</p>
                                <p class="message_list_num" @click="onClickMessDetail('/productAudit')">
                                    {{ printMap.passPresentation }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="center_list_box center_list_box2">
                        <h5>设计统计</h5>
                        <div class="message_list_box">
                            <div class="message_list">
                                <p>设计师</p>
                                <p class="message_list_num" @click="onClickMessDetail('/designerManage')">
                                    {{ designMap.passDesigner }}</p>
                            </div>
                            <div class="message_list">
                                <p>需求总数</p>
                                <p class="message_list_num" @click="onClickMessDetail('/demandAudit')">
                                    {{ designMap.passDemand }}</p>
                            </div>
                            <div class="message_list">
                                <p>模型总数</p>
                                <p class="message_list_num" @click="onClickMessDetail('/modelAudit')">
                                    {{ designMap.passModel }}</p>
                            </div>
                            <div class="message_list">
                                <p>成品总数</p>
                                <p class="message_list_num" @click="onClickMessDetail('/worksAudit')">
                                    {{ designMap.passProduct }}</p>
                            </div>
                            <div class="message_list">
                                <p>作品总数</p>
                                <p class="message_list_num" @click="onClickMessDetail('/designAudit')">
                                    {{ designMap.passDesign }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="center_list_box center_list_box2">
                        <h5>商城统计</h5>
                        <div class="message_list_box">
                            <div class="message_list">
                                <p>商家总数</p>
                                <p class="message_list_num" @click="onClickMessDetail('/shopSettled')">
                                    {{ printMap.passShopSettled }}</p>
                            </div>
                            <div class="message_list">
                                <p>在售商品总数</p>
                                <p class="message_list_num" @click="onClickMessDetail('/goodsAudit')">
                                    {{ printMap.passGoods }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="center_list_box center_list_box2">
                        <h5>先行订单</h5>
                        <div class="message_list_box">
                            <div class="message_list">
                                <p>待确认</p>
                                <p class="message_list_num" @click="onClickMessDetail('/designOrderList1')">
                                    {{ sellerMap.confirmNum }}</p>
                            </div>
                            <div class="message_list">
                                <p>待付款</p>
                                <p class="message_list_num" @click="onClickMessDetail('/designOrderList1')">
                                    {{ sellerMap.payNum }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="center_list_box center_list_box2">
                        <h5>销售统计</h5>
                        <div class="message_list_box">
                            <div class="message_list">
                                <p>总销售金额</p>
                                <p class="message_list_num">{{ sellerMap.countSeller }}</p>
                            </div>
                            <div class="message_list">
                                <p>商品销售额</p>
                                <p class="message_list_num">{{ sellerMap.SHOP }}</p>
                            </div>
                            <div class="message_list">
                                <p>打印销售额</p>
                                <p class="message_list_num">{{ sellerMap.PRINT }}</p>
                            </div>
                            <div class="message_list">
                                <p>服务销售额</p>
                                <p class="message_list_num">{{ sellerMap.SERVICE }}</p>
                            </div>
                            <div class="message_list">
                                <p>设计销售额</p>
                                <p class="message_list_num">{{ sellerMap.DESIGN }}</p>
                            </div>
                            <div class="message_list">
                                <p>模型销售额</p>
                                <p class="message_list_num">{{ sellerMap.MODEL }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    indexCountNumPrint,
    indexCountNumDesign,
    getNewcurrent,
    getMenuList,
    indexSellerCountPrint
} from "../../utils/interface";

export default {
    name: "homePage",
    data() {
        return {
            printMap: {
                examineProviders: 0,
                examineShopSettled: 0,
                examineMaterial: 0,
                examineServiceability: 0,
                examinePresentation: 0,
                examineGoods: 0,
                passProviders: 0,
                passMaterial: 0,
                passServiceability: 0,
                passPresentation: 0,
                passShopSettled: 0,
                passGoods: 0
            },
            designMap: {
                examineDesigner: 0,
                examineDemand: 0,
                examineModel: 0,
                examineProduct: 0,
                examineDesign: 0,
                passDesigner: 0,
                passDemand: 0,
                passModel: 0,
                passProduct: 0,
                passDesign: 0
            },
            sellerMap: {
                confirmNum: 0,
                payNum: 0,
                countSeller: 0,
                SHOP: 0,
                PRINT: 0,
                SERVICE: 0,
                DESIGN: 0,
                MODEL: 0
            },
            userInfo: "",
            navActive: ""
        };
    },
    created() {
        this.init();
        getMenuList().then(res => {
            this.navActive = res;
        })
    },
    methods: {
        init() {
            getNewcurrent().then((res) => {
                this.userInfo = res;
            });
            indexCountNumPrint().then((res) => {
                this.printMap = res.data;
            });
            indexCountNumDesign().then((res) => {
                this.designMap = res.data;
            });
            indexSellerCountPrint().then((res) => {
                this.sellerMap = res.data;
            })
        },
        onClickMessDetail(path) {
            console.log('path', path);
            if(path == '/designOrderList1'){
                this.$bus.$emit('navActive', this.navActive[1])
            }else if (path == "/shopSettled" || path === "/shopProviders" || path == "/designerManage") {
                this.$bus.$emit('navActive', this.navActive[3])
            } else {
                this.$bus.$emit('navActive', this.navActive[2])
            }
            this.$router.replace(path)
        },
    }
};
</script>

<style scoped lang="less">
.homePage {
    background: #fff;
    margin: 15px;
    box-sizing: border-box;

    .welcome {
        font-size: 18px;
        border-bottom: 1px solid #efefef;
        padding: 15px;
    }

    .homePage_box {
        padding: 5px 15px 15px;

        .homePage_box_mess {
            font-size: 13px;
            color: #666;
            margin-left: 20px;
            margin-bottom: 20px;

            span {
                color: #409eff;
                font-weight: bold;
            }
        }

        .homePage_box_center {
            margin-bottom: 40px;

            .homePage_box_center_title {
                border-bottom: 1px solid #efefef;

                h5 {
                    border-bottom: 2px solid #409eff;
                    width: 80px;
                    text-align: center;
                    padding-bottom: 10px;
                    margin: 0;
                }
            }

            .center_list {
                display: flex;
                flex-wrap: wrap;
                margin: 0 16px;

                .center_list_box {
                    box-shadow: 0px 0px 10px 5px #efefef;
                    padding: 10px;
                    border-radius: 10px;
                    margin-top: 20px;
                    margin-right: 30px;

                    h5 {
                        margin: 5px 0 15px;
                    }

                    .message_list_box {
                        display: flex;

                        .message_list {
                            border-radius: 5px;
                            background: rgba(100, 148, 237, 0.247);
                            min-width: 100px;
                            text-align: center;
                            font-size: 13px;
                            margin-right: 20px;

                            &:nth-last-of-type(1) {
                                margin-right: 0;
                            }

                            .message_list_num {
                                color: #409eff;
                                font-weight: bold;
                                cursor: pointer;
                            }
                        }
                    }
                }

                .center_list_box2 {
                    &:nth-of-type(1) {
                        width: 243px;
                        padding-bottom: 0;

                        .message_list_box {
                            flex-wrap: wrap;

                            .message_list {
                                margin-bottom: 20px;
                                margin-right: 20px;

                                &:nth-of-type(2n+2) {
                                    margin-right: 0;
                                }
                            }
                        }
                    }

                    &:nth-of-type(2) {
                        width: 362px;
                        padding-bottom: 0;

                        .message_list_box {
                            flex-wrap: wrap;

                            .message_list {
                                margin-bottom: 20px;
                                margin-right: 20px;

                                &:nth-of-type(3n+3) {
                                    margin-right: 0;
                                }
                            }
                        }
                    }

                    &:nth-of-type(3) {
                        width: 243px;
                        padding-bottom: 0;

                        .message_list_box {
                            flex-wrap: wrap;

                            .message_list {
                                margin-bottom: 20px;
                                margin-right: 20px;

                                &:nth-of-type(2n+2) {
                                    margin-right: 0;
                                }
                            }
                        }
                    }

                    //   .message_list_box {
                    //     flex-wrap: wrap;
                    //     .message_list {
                    //       margin-bottom: 20px;
                    //       margin-right: 46px;
                    //       min-width: 130px;
                    //       &:nth-last-of-type(2n + 2) {
                    //         margin-right: 0;
                    //       }
                    //     }
                    //   }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/homePage.vue